
 <div class="copyright">© Copyright {{ currentYear }} BioData Solutions. All Rights Reserved.</div>
<div class="version">Version 2.0</div>
